// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { ControlRow, ControlRowT, verifyControlRow } from "./control-row";
import { Entry, EntryT, verifyEntry } from "./entry";
import { EventDecode, EventDecodeT, verifyEventDecode } from "./event-decode";
import { EventFamily } from "./event-family";
import { EventRow, EventRowT, verifyEventRow } from "./event-row";
import { ExpandedKey, ExpandedKeyT } from "./expanded-key";
import { ProductType } from "./product-type";
import { ProfileId } from "./profile-id";
import { Template, TemplateT, verifyTemplate } from "./template";

/**
 * The derived translation, a function of the product, the bundle, the
 * overrides and the converter's profiles. It records no provenance.
 */
export class TranslationTable implements flatbuffers.IUnpackableObject<TranslationTableT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): TranslationTable {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsTranslationTable(
    bb: flatbuffers.ByteBuffer,
    obj?: TranslationTable,
  ): TranslationTable {
    return (obj || new TranslationTable()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsTranslationTable(
    bb: flatbuffers.ByteBuffer,
    obj?: TranslationTable,
  ): TranslationTable {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new TranslationTable()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static bufferHasIdentifier(bb: flatbuffers.ByteBuffer): boolean {
    return bb.__has_identifier("MCET");
  }

  formatVersion(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
  }

  canonicalFormat(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
  }

  schemaFingerprint(): string;
  schemaFingerprint(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  schemaFingerprint(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  productType(): ProductType | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : null;
  }

  idlSha256(): string;
  idlSha256(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  idlSha256(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  bundleSha256(): string;
  bundleSha256(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  bundleSha256(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  eventsSha256(): string | null;
  eventsSha256(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  eventsSha256(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  overridesSha256(): string | null;
  overridesSha256(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  overridesSha256(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  templates(index: number, obj?: Template): Template | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset
      ? (obj || new Template()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  templatesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  entries(index: number, obj?: Entry): Entry | null {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset
      ? (obj || new Entry()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  entriesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  expanded(index: number, obj?: ExpandedKey): ExpandedKey | null {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset
      ? (obj || new ExpandedKey()).__init(
          this.bb!.__vector(this.bb_pos + offset) + index * 20,
          this.bb!,
        )
      : null;
  }

  expandedLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  profileId(): ProfileId {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ProfileId.Unspecified;
  }

  profileVersion(): number {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
  }

  eventDecode(obj?: EventDecode): EventDecode | null {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset
      ? (obj || new EventDecode()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  events(index: number, obj?: EventRow): EventRow | null {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset
      ? (obj || new EventRow()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  eventsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  eventsFamily(): EventFamily {
    const offset = this.bb!.__offset(this.bb_pos, 34);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : EventFamily.Unspecified;
  }

  eventSchemaVersion(): string | null;
  eventSchemaVersion(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  eventSchemaVersion(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 36);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  controls(index: number, obj?: ControlRow): ControlRow | null {
    const offset = this.bb!.__offset(this.bb_pos, 38);
    return offset
      ? (obj || new ControlRow()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  controlsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 38);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startTranslationTable(builder: flatbuffers.Builder) {
    builder.startObject(18);
  }

  static addFormatVersion(builder: flatbuffers.Builder, formatVersion: number) {
    builder.addFieldInt16(0, formatVersion, 0);
  }

  static addCanonicalFormat(builder: flatbuffers.Builder, canonicalFormat: number) {
    builder.addFieldInt16(1, canonicalFormat, 0);
  }

  static addSchemaFingerprint(
    builder: flatbuffers.Builder,
    schemaFingerprintOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(2, schemaFingerprintOffset, 0);
  }

  static addProductType(builder: flatbuffers.Builder, productType: ProductType) {
    builder.addFieldInt8(3, productType, null);
  }

  static addIdlSha256(builder: flatbuffers.Builder, idlSha256Offset: flatbuffers.Offset) {
    builder.addFieldOffset(4, idlSha256Offset, 0);
  }

  static addBundleSha256(builder: flatbuffers.Builder, bundleSha256Offset: flatbuffers.Offset) {
    builder.addFieldOffset(5, bundleSha256Offset, 0);
  }

  static addEventsSha256(builder: flatbuffers.Builder, eventsSha256Offset: flatbuffers.Offset) {
    builder.addFieldOffset(6, eventsSha256Offset, 0);
  }

  static addOverridesSha256(
    builder: flatbuffers.Builder,
    overridesSha256Offset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(7, overridesSha256Offset, 0);
  }

  static addTemplates(builder: flatbuffers.Builder, templatesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, templatesOffset, 0);
  }

  static createTemplatesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startTemplatesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addEntries(builder: flatbuffers.Builder, entriesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(9, entriesOffset, 0);
  }

  static createEntriesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startEntriesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addExpanded(builder: flatbuffers.Builder, expandedOffset: flatbuffers.Offset) {
    builder.addFieldOffset(10, expandedOffset, 0);
  }

  static startExpandedVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(20, numElems, 4);
  }

  static addProfileId(builder: flatbuffers.Builder, profileId: ProfileId) {
    builder.addFieldInt8(11, profileId, ProfileId.Unspecified);
  }

  static addProfileVersion(builder: flatbuffers.Builder, profileVersion: number) {
    builder.addFieldInt16(12, profileVersion, 0);
  }

  static addEventDecode(builder: flatbuffers.Builder, eventDecodeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(13, eventDecodeOffset, 0);
  }

  static addEvents(builder: flatbuffers.Builder, eventsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(14, eventsOffset, 0);
  }

  static createEventsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startEventsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addEventsFamily(builder: flatbuffers.Builder, eventsFamily: EventFamily) {
    builder.addFieldInt8(15, eventsFamily, EventFamily.Unspecified);
  }

  static addEventSchemaVersion(
    builder: flatbuffers.Builder,
    eventSchemaVersionOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(16, eventSchemaVersionOffset, 0);
  }

  static addControls(builder: flatbuffers.Builder, controlsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(17, controlsOffset, 0);
  }

  static createControlsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startControlsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endTranslationTable(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 8); // schema_fingerprint
    builder.requiredField(offset, 12); // idl_sha256
    builder.requiredField(offset, 14); // bundle_sha256
    builder.requiredField(offset, 20); // templates
    builder.requiredField(offset, 22); // entries
    builder.requiredField(offset, 24); // expanded
    return offset;
  }

  static finishTranslationTableBuffer(builder: flatbuffers.Builder, offset: flatbuffers.Offset) {
    builder.finish(offset, "MCET");
  }

  static finishSizePrefixedTranslationTableBuffer(
    builder: flatbuffers.Builder,
    offset: flatbuffers.Offset,
  ) {
    builder.finish(offset, "MCET", true);
  }

  unpack(): TranslationTableT {
    return new TranslationTableT(
      this.formatVersion(),
      this.canonicalFormat(),
      this.schemaFingerprint(),
      this.productType(),
      this.idlSha256(),
      this.bundleSha256(),
      this.eventsSha256(),
      this.overridesSha256(),
      this.bb!.createObjList<Template, TemplateT>(
        this.templates.bind(this),
        this.templatesLength(),
      ),
      this.bb!.createObjList<Entry, EntryT>(this.entries.bind(this), this.entriesLength()),
      this.bb!.createObjList<ExpandedKey, ExpandedKeyT>(
        this.expanded.bind(this),
        this.expandedLength(),
      ),
      this.profileId(),
      this.profileVersion(),
      this.eventDecode() !== null ? this.eventDecode()!.unpack() : null,
      this.bb!.createObjList<EventRow, EventRowT>(this.events.bind(this), this.eventsLength()),
      this.eventsFamily(),
      this.eventSchemaVersion(),
      this.bb!.createObjList<ControlRow, ControlRowT>(
        this.controls.bind(this),
        this.controlsLength(),
      ),
    );
  }

  unpackTo(_o: TranslationTableT): void {
    _o.formatVersion = this.formatVersion();
    _o.canonicalFormat = this.canonicalFormat();
    _o.schemaFingerprint = this.schemaFingerprint();
    _o.productType = this.productType();
    _o.idlSha256 = this.idlSha256();
    _o.bundleSha256 = this.bundleSha256();
    _o.eventsSha256 = this.eventsSha256();
    _o.overridesSha256 = this.overridesSha256();
    _o.templates = this.bb!.createObjList<Template, TemplateT>(
      this.templates.bind(this),
      this.templatesLength(),
    );
    _o.entries = this.bb!.createObjList<Entry, EntryT>(
      this.entries.bind(this),
      this.entriesLength(),
    );
    _o.expanded = this.bb!.createObjList<ExpandedKey, ExpandedKeyT>(
      this.expanded.bind(this),
      this.expandedLength(),
    );
    _o.profileId = this.profileId();
    _o.profileVersion = this.profileVersion();
    _o.eventDecode = this.eventDecode() !== null ? this.eventDecode()!.unpack() : null;
    _o.events = this.bb!.createObjList<EventRow, EventRowT>(
      this.events.bind(this),
      this.eventsLength(),
    );
    _o.eventsFamily = this.eventsFamily();
    _o.eventSchemaVersion = this.eventSchemaVersion();
    _o.controls = this.bb!.createObjList<ControlRow, ControlRowT>(
      this.controls.bind(this),
      this.controlsLength(),
    );
  }

  unpackFields(...fields: string[]): TranslationTableT {
    const t = new TranslationTableT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("format_version")) {
      t.formatVersion = this.formatVersion();
    }
    if (fieldSet.has("canonical_format")) {
      t.canonicalFormat = this.canonicalFormat();
    }
    if (fieldSet.has("schema_fingerprint")) {
      t.schemaFingerprint = this.schemaFingerprint();
    }
    if (fieldSet.has("product_type")) {
      t.productType = this.productType();
    }
    if (fieldSet.has("idl_sha256")) {
      t.idlSha256 = this.idlSha256();
    }
    if (fieldSet.has("bundle_sha256")) {
      t.bundleSha256 = this.bundleSha256();
    }
    if (fieldSet.has("events_sha256")) {
      t.eventsSha256 = this.eventsSha256();
    }
    if (fieldSet.has("overrides_sha256")) {
      t.overridesSha256 = this.overridesSha256();
    }
    if (fieldSet.has("templates")) {
      t.templates = this.bb!.createObjList<Template, TemplateT>(
        this.templates.bind(this),
        this.templatesLength(),
      );
    }
    if (fieldSet.has("entries")) {
      t.entries = this.bb!.createObjList<Entry, EntryT>(
        this.entries.bind(this),
        this.entriesLength(),
      );
    }
    if (fieldSet.has("expanded")) {
      t.expanded = this.bb!.createObjList<ExpandedKey, ExpandedKeyT>(
        this.expanded.bind(this),
        this.expandedLength(),
      );
    }
    if (fieldSet.has("profile_id")) {
      t.profileId = this.profileId();
    }
    if (fieldSet.has("profile_version")) {
      t.profileVersion = this.profileVersion();
    }
    if (fieldSet.has("event_decode")) {
      t.eventDecode = this.eventDecode() !== null ? this.eventDecode()!.unpack() : null;
    }
    if (fieldSet.has("events")) {
      t.events = this.bb!.createObjList<EventRow, EventRowT>(
        this.events.bind(this),
        this.eventsLength(),
      );
    }
    if (fieldSet.has("events_family")) {
      t.eventsFamily = this.eventsFamily();
    }
    if (fieldSet.has("event_schema_version")) {
      t.eventSchemaVersion = this.eventSchemaVersion();
    }
    if (fieldSet.has("controls")) {
      t.controls = this.bb!.createObjList<ControlRow, ControlRowT>(
        this.controls.bind(this),
        this.controlsLength(),
      );
    }
    return t;
  }
}

export class TranslationTableT implements flatbuffers.IGeneratedObject {
  constructor(
    public formatVersion: number = 0,
    public canonicalFormat: number = 0,
    public schemaFingerprint: string | Uint8Array | null = null,
    public productType: ProductType | null = null,
    public idlSha256: string | Uint8Array | null = null,
    public bundleSha256: string | Uint8Array | null = null,
    public eventsSha256: string | Uint8Array | null = null,
    public overridesSha256: string | Uint8Array | null = null,
    public templates: TemplateT[] = [],
    public entries: EntryT[] = [],
    public expanded: ExpandedKeyT[] = [],
    public profileId: ProfileId = ProfileId.Unspecified,
    public profileVersion: number = 0,
    public eventDecode: EventDecodeT | null = null,
    public events: EventRowT[] = [],
    public eventsFamily: EventFamily = EventFamily.Unspecified,
    public eventSchemaVersion: string | Uint8Array | null = null,
    public controls: ControlRowT[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.schemaFingerprint === null || this.schemaFingerprint === undefined) {
      throw new Error('Required field "schema_fingerprint" is not set');
    }
    if (this.idlSha256 === null || this.idlSha256 === undefined) {
      throw new Error('Required field "idl_sha256" is not set');
    }
    if (this.bundleSha256 === null || this.bundleSha256 === undefined) {
      throw new Error('Required field "bundle_sha256" is not set');
    }
    if (this.templates === null || this.templates === undefined) {
      throw new Error('Required field "templates" is not set');
    }
    if (this.entries === null || this.entries === undefined) {
      throw new Error('Required field "entries" is not set');
    }
    if (this.expanded === null || this.expanded === undefined) {
      throw new Error('Required field "expanded" is not set');
    }
    const schemaFingerprint =
      this.schemaFingerprint !== null ? builder.createString(this.schemaFingerprint!) : 0;
    const idlSha256 = this.idlSha256 !== null ? builder.createString(this.idlSha256!) : 0;
    const bundleSha256 = this.bundleSha256 !== null ? builder.createString(this.bundleSha256!) : 0;
    const eventsSha256 = this.eventsSha256 !== null ? builder.createString(this.eventsSha256!) : 0;
    const overridesSha256 =
      this.overridesSha256 !== null ? builder.createString(this.overridesSha256!) : 0;
    const templates = TranslationTable.createTemplatesVector(
      builder,
      builder.createObjectOffsetList(this.templates),
    );
    const entries = TranslationTable.createEntriesVector(
      builder,
      builder.createObjectOffsetList(this.entries),
    );
    const expanded = builder.createStructOffsetList(
      this.expanded,
      TranslationTable.startExpandedVector,
    );
    const eventDecode = this.eventDecode !== null ? this.eventDecode!.pack(builder) : 0;
    const events = TranslationTable.createEventsVector(
      builder,
      builder.createObjectOffsetList(this.events),
    );
    const eventSchemaVersion =
      this.eventSchemaVersion !== null ? builder.createString(this.eventSchemaVersion!) : 0;
    const controls = TranslationTable.createControlsVector(
      builder,
      builder.createObjectOffsetList(this.controls),
    );

    TranslationTable.startTranslationTable(builder);
    TranslationTable.addFormatVersion(builder, this.formatVersion);
    TranslationTable.addCanonicalFormat(builder, this.canonicalFormat);
    TranslationTable.addSchemaFingerprint(builder, schemaFingerprint);
    if (this.productType !== null) TranslationTable.addProductType(builder, this.productType);
    TranslationTable.addIdlSha256(builder, idlSha256);
    TranslationTable.addBundleSha256(builder, bundleSha256);
    TranslationTable.addEventsSha256(builder, eventsSha256);
    TranslationTable.addOverridesSha256(builder, overridesSha256);
    TranslationTable.addTemplates(builder, templates);
    TranslationTable.addEntries(builder, entries);
    TranslationTable.addExpanded(builder, expanded);
    TranslationTable.addProfileId(builder, this.profileId);
    TranslationTable.addProfileVersion(builder, this.profileVersion);
    TranslationTable.addEventDecode(builder, eventDecode);
    TranslationTable.addEvents(builder, events);
    TranslationTable.addEventsFamily(builder, this.eventsFamily);
    TranslationTable.addEventSchemaVersion(builder, eventSchemaVersion);
    TranslationTable.addControls(builder, controls);

    return TranslationTable.endTranslationTable(builder);
  }

  clone(): TranslationTableT {
    const obj = new TranslationTableT();
    obj.formatVersion = this.formatVersion;
    obj.canonicalFormat = this.canonicalFormat;
    obj.schemaFingerprint = this.schemaFingerprint;
    obj.productType = this.productType;
    obj.idlSha256 = this.idlSha256;
    obj.bundleSha256 = this.bundleSha256;
    obj.eventsSha256 = this.eventsSha256;
    obj.overridesSha256 = this.overridesSha256;
    obj.templates = this.templates.map((e) => e.clone());
    obj.entries = this.entries.map((e) => e.clone());
    obj.expanded = this.expanded.map((e) => e.clone());
    obj.profileId = this.profileId;
    obj.profileVersion = this.profileVersion;
    obj.eventDecode = this.eventDecode !== null ? this.eventDecode!.clone() : null;
    obj.events = this.events.map((e) => e.clone());
    obj.eventsFamily = this.eventsFamily;
    obj.eventSchemaVersion = this.eventSchemaVersion;
    obj.controls = this.controls.map((e) => e.clone());
    return obj;
  }

  equals(other: TranslationTableT): boolean {
    if (this.formatVersion !== other.formatVersion) return false;
    if (this.canonicalFormat !== other.canonicalFormat) return false;
    if (this.schemaFingerprint !== other.schemaFingerprint) return false;
    if (this.productType !== other.productType) return false;
    if (this.idlSha256 !== other.idlSha256) return false;
    if (this.bundleSha256 !== other.bundleSha256) return false;
    if (this.eventsSha256 !== other.eventsSha256) return false;
    if (this.overridesSha256 !== other.overridesSha256) return false;
    if (this.templates.length !== other.templates.length) return false;
    for (let i = 0; i < this.templates.length; i++) {
      const a = this.templates[i];
      const b = other.templates[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.entries.length !== other.entries.length) return false;
    for (let i = 0; i < this.entries.length; i++) {
      const a = this.entries[i];
      const b = other.entries[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.expanded.length !== other.expanded.length) return false;
    for (let i = 0; i < this.expanded.length; i++) {
      const a = this.expanded[i];
      const b = other.expanded[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.profileId !== other.profileId) return false;
    if (this.profileVersion !== other.profileVersion) return false;
    if (this.eventDecode !== null && other.eventDecode !== null) {
      if (!this.eventDecode!.equals(other.eventDecode!)) return false;
    } else if (this.eventDecode !== other.eventDecode) return false;
    if (this.events.length !== other.events.length) return false;
    for (let i = 0; i < this.events.length; i++) {
      const a = this.events[i];
      const b = other.events[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.eventsFamily !== other.eventsFamily) return false;
    if (this.eventSchemaVersion !== other.eventSchemaVersion) return false;
    if (this.controls.length !== other.controls.length) return false;
    for (let i = 0; i < this.controls.length; i++) {
      const a = this.controls[i];
      const b = other.controls[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifyTranslationTable(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 2);
    verifier.checkScalarField(tablePos, 6, 2);
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 8, "schema_fingerprint");
    verifier.checkScalarField(tablePos, 10, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 12, "idl_sha256");
    {
      const pos = verifier.checkOffsetField(tablePos, 14);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 14, "bundle_sha256");
    {
      const pos = verifier.checkOffsetField(tablePos, 16);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 18);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 20);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyTemplate);
      }
    }
    verifier.checkRequiredField(tablePos, 20, "templates");
    {
      const pos = verifier.checkOffsetField(tablePos, 22);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyEntry);
      }
    }
    verifier.checkRequiredField(tablePos, 22, "entries");
    {
      const pos = verifier.checkOffsetField(tablePos, 24);
      if (pos !== 0) {
        verifier.checkVector(pos, 20);
      }
    }
    verifier.checkRequiredField(tablePos, 24, "expanded");
    verifier.checkScalarField(tablePos, 26, 1);
    verifier.checkScalarField(tablePos, 28, 2);
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 30);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyEventDecode(verifier, fieldPos + tableOffset);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 32);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyEventRow);
      }
    }
    verifier.checkScalarField(tablePos, 34, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 36);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 38);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyControlRow);
      }
    }
  } finally {
    verifier.popDepth();
  }
}

export function verifyRootAsTranslationTable(
  buf: DataView,
  opts?: flatbuffers.VerifierOptions,
): void {
  const verifier = new flatbuffers.Verifier(buf, opts);
  const tablePos = verifier.readUint32(0);
  verifyTranslationTable(verifier, tablePos);
}
